<template>
  <div class="multi-button-filter">
    <span v-if="label" small class="mr-1">
      {{ label }}
    </span>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          dark
          rounded
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="ml-1"
        >
          {{ selectedOption.label }}
          <v-icon right class="ml-0">mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="option in options"
          :key="option.value"
          @click="handleClick(option.value)"
          :class="{ 'primary--text': value === option.value }"
        >
          <v-list-item-title>
            {{ option.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'MultiButtonFilter',

  props: {
    value: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator (filterOptions) {
        return filterOptions.every(
          option => 'value' in option && 'label' in option
        )
      }
    },
    label: {
      type: String,
      default: null
    }
  },

  computed: {
    selectedOption () {
      return this.options.find(option => option.value === this.value) || this.options[0]
    }
  },

  methods: {
    handleClick (selectedValue) {
      this.$emit('input', selectedValue)
    }
  }
}
</script>
